export default "__VITE_ASSET__BSApxgzj__"